<template>
  <div>
    <page-main
      ref="main"
      :tableData="tableData"
      :tablePage="page"
      :loading="loading"
      :disabled="disabled"
      @reload="reload"
      @openEditFormDialog="openEditFormDialog"
      @batchDel="submitDel"
    >
      <!-- <page-header
        ref="header"
        slot="header"
        :disabled="disabled"
        @query="getData"
        @reset="resetPage"
        @openEditFormDialog="openEditFormDialog"
        @batchDel="batchDel"
      >
      </page-header> -->
    </page-main>
    <el-dialog
      v-if="editFormDialogOptions.visible"
      show-close
      visible
      width="900px"
      :title="editFormDialogOptions.title"
      :close-on-click-modal="false"
      :before-close="() => $refs.editForm.cancel()"
    >
      <batch-goods-table-edit-form
        ref="editForm"
        :orderBatchCode="editFormDialogOptions.orderBatchCode"
        :code="editFormDialogOptions.code"
        :changeOrderCode="editFormDialogOptions.changeOrderCode"
        :disabled="editFormDialogOptions.disabled"
        :params="editFormDialogOptions.params"
        :isAdd="editFormDialogOptions.isAdd"
        :isCheckBox="editFormDialogOptions.isCheckBox"
        @reload="reload"
        @close="closeEditFormDialog"
      />
      <span slot="footer">
        <el-button size="small" @click="$refs.editForm.cancel()">{{
           $l('INDEX.btn_cancel') || '取消'
        }}</el-button>
        <el-button
          type="primary"
          size="small"
          v-if="!editFormDialogOptions.disabled"
          @click="$refs.editForm.save()"
          >{{  $l('INDEX.btn_save') || '保存' }}</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>
<script>
import PageMain from './main.vue'
// import PageHeader from './header.vue'
import BaseTable from '@/mixins/base-table'
import BatchGoodsTableEditForm from '../batch-goods-table-edit-form/index.vue'

export default {
  components: {
    PageMain,
    // PageHeader,
    BatchGoodsTableEditForm,
  },
  mixins: [BaseTable],
  props: {
    changeOrderCode: {
      type: String,
      default: '',
    },
    orderBatchCode: {
      type: String,
      default: '',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      editFormDialogOptions: {
        visible: false,
        code: '',
      },
    }
  },
  mounted() {
    this.getData()
  },
  methods: {
    getData(form) {
      this.loading = true
      this.$api
        .changeOrderBatchGoodsListApi({
          changeOrderCode: this.changeOrderCode,
          orderBatchCode: this.orderBatchCode,
          ...form,
        })
        .then((res) => {
          this.loading = false
          this.setData(res)
        })
        .catch(() => {
          this.loading = false
        })
    },
    openEditFormDialog({ type, params = {} }) {
      const types = {
        edit: this. $l('INDEX.dialog_title_batch_goods_edit') || '编辑批次交货产品',
        add: this. $l('INDEX.dialog_title_batch_goods_add') || '新增批次交货产品',
      }
      this.editFormDialogOptions = {
        visible: true,
        type,
        title: types[type],
        code: params.orderBatchGoodsCode,
        orderBatchCode: this.orderBatchCode,
        changeOrderCode: this.changeOrderCode,
        disabled: type === 'detail',
        isAdd: type === 'add',
        isCheckBox: type != 'edit',
      }
    },
    closeEditFormDialog() {
      this.editFormDialogOptions.visible = false
    },
    //批量删除的操作
    batchDel() {
      const listCode = this.$refs.main.getCheckboxRecords()
      if (listCode) this.submitDel(listCode)
    },
    submitDel(listCode) {
      this.$confirm(
        this. $l('INDEX.INDEX.tips_delete') || '是否要删除该记录？',
        this. $l('INDEX.INDEX.label_completeDesc') || '确认信息',
        {
          confirmButtonText:
            this. $l('INDEX.INDEX.product_dialog_btn_confirm') || '确定',
          cancelButtonText: this. $l('INDEX.INDEX.btn_cancel') || '取消',
          type: 'warning',
        }
      )
        .then(() => {
          this.$api.orderBatchGoodsDelApi({ listCode }).then(() => {
            this.$message({
              showClose: true,
              message: this. $l('INDEX.INDEX.tips_delete_ok') || '删除成功！',
              type: 'success',
            })
            this.$refs.header.query()
          })
        })
        .catch(() => {})
    },
  },
}
</script>
